import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>BAYT AL-KHAYR</h3>
          <p>EST. 2026 • MEDINA</p>
          <p>Serving the World Globally</p>
        </div>
        
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/collection">Collection</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Contact Info</h4>
          <p>📍 Medina, Saudi Arabia</p>
          <p>📧 info@baytal-khayr.com</p>
          <p>🌐 Global Shipping Available</p>
        </div>
        
        <div className="footer-section">
          <h4>Certifications</h4>
          <p>✓ Halal Certified</p>
          <p>✓ Ethically Sourced</p>
          <p>✓ Secure Checkout</p>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>Bayt Al-Khayr © 2026 • Medina, Saudi Arabia • Serving the World Globally • Halal | Ethical | Global</p>
      </div>
    </footer>
  );
}

export default Footer;
